__turbopack_context__.v({
  "animationStateIn": "PromotionalTicker-module-scss-module__nIbbrW__animationStateIn",
  "animationStateOut": "PromotionalTicker-module-scss-module__nIbbrW__animationStateOut",
  "animationStateStatic": "PromotionalTicker-module-scss-module__nIbbrW__animationStateStatic",
  "promotional-ticker-fade-in": "PromotionalTicker-module-scss-module__nIbbrW__promotional-ticker-fade-in",
  "promotional-ticker-fade-out": "PromotionalTicker-module-scss-module__nIbbrW__promotional-ticker-fade-out",
  "promotionalTickerContainer": "PromotionalTicker-module-scss-module__nIbbrW__promotionalTickerContainer",
  "promotionalTickerHidden": "PromotionalTicker-module-scss-module__nIbbrW__promotionalTickerHidden",
  "promotionalTickerIcon": "PromotionalTicker-module-scss-module__nIbbrW__promotionalTickerIcon",
  "promotionalTickerItem": "PromotionalTicker-module-scss-module__nIbbrW__promotionalTickerItem",
  "promotionalTickerLink": "PromotionalTicker-module-scss-module__nIbbrW__promotionalTickerLink",
});
